import React, { Component } from 'react';
import { Divider, Grid, Segment, Button, Form, Message } from 'semantic-ui-react'
import { budgetURL } from "../../shared/urls/clientapi";
import { callService, GET, PUT } from "../../shared/serviceInvoker";
import { returnErrorMessage } from "../../shared/utils";
import BudgetHeader from "../BudgetHeader/index";
import BudgetItem from "../BudgetItem/index";
import ReactGA from 'react-ga';
import { trackEvent } from '../../shared/tracking';

export default class Budget extends Component {
    constructor() {
        super();   
        let url = budgetURL.replace('{contact_id}', sessionStorage.contact_id);
        this.budgetURL = url + 'yes';
        
        this.state = {
            success: false,
            error: false,
            errorMessage: '',
            showLoader: true,
            budget_totals: [],
            take_home_pay: 0,
            other_income: 0,
            alimony: 0,
            child_support_gain: 0,
            social_security: 0,
            retirement_income: 0,
            checking_account: 0,
            checking_account_lien: 0,
            savings_account: 0,
            savings_account_lien: 0,
            cash: 0,
            cash_lien: 0,
            property_balance: 0,
            property_balance_lien: 0,
            stocks: 0,
            stocks_lien: 0,
            vehicles: 0,
            vehicles_lien: 0,
            other_incomes: 0,
            other_incomes_lien: 0,
            rent: 0,
            utilities: 0,
            transportation: 0,
            insurance_premiums: 0,
            food: 0,
            telephone: 0,
            medical_bills: 0,
            back_taxes: 0,
            student_loans: 0,
            child_support_loss: 0,
            child_care: 0,
            other_expenses: 0,
            rent_2: 0,
            auto_other: 0,
            tv: 0,
            charity: 0,
            clothing: 0,
            education: 0,
            entertainment: 0,
            health: 0,
            home_insurance: 0,
            household_items: 0,
            life_insurance: 0,
            laundry: 0,
            medical_care: 0,
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        const number = (target.validity.valid) ? value : this.state[name];
        this.setState({ [name]: number });
    }

    componentDidMount() {

        callService(
            GET,
            this.budgetURL,
            null,
            response => {
                let budget_totals = response.data.data.totals;
                let budget_incomes = response.data.data.incomes;
                let budget_assets = response.data.data.assets;
                // let budget_liens = response.data.data.liens;
                let budget_expenses = response.data.data.expenses;
                this.setState({
                    showLoader: false,
                    budget_totals: budget_totals,
                    take_home_pay: budget_incomes.take_home_pay || 0,
                    other_income: budget_incomes.other_income || 0,
                    alimony: budget_incomes.alimony || 0,
                    child_support_gain: budget_incomes.child_support_gain || 0,
                    social_security: budget_incomes.social_security || 0,
                    retirement_income: budget_incomes.retirement_income || 0,
                    checking_account: budget_assets.checking_account || 0,
                    checking_account_lien: budget_assets.checking_account_lien || 0,
                    savings_account: budget_assets.savings_account || 0,
                    savings_account_lien: budget_assets.savings_account_lien || 0,
                    cash: budget_assets.cash || 0,
                    cash_lien: budget_assets.cash_lien || 0,
                    property_balance: budget_assets.property_balance || 0,
                    property_balance_lien: budget_assets.property_balance_lien || 0,
                    stocks: budget_assets.stocks || 0,
                    stocks_lien: budget_assets.stocks_lien || 0,
                    vehicles: budget_assets.vehicles || 0,
                    vehicles_lien: budget_assets.vehicles_lien || 0,
                    other_incomes: budget_assets.other_incomes || 0,
                    other_incomes_lien: budget_assets.other_incomes_lien || 0,
                    rent: budget_expenses.rent || 0,
                    utilities: budget_expenses.utilities || 0,
                    transportation: budget_expenses.transportation || 0,
                    insurance_premiums: budget_expenses.insurance_premiums || 0,
                    food: budget_expenses.food || 0,
                    telephone: budget_expenses.telephone || 0,
                    medical_bills: budget_expenses.medical_bills || 0,
                    back_taxes: budget_expenses.back_taxes || 0,
                    student_loans: budget_expenses.student_loans || 0,
                    child_support_loss: budget_expenses.child_support_loss || 0,
                    child_care: budget_expenses.child_care || 0,
                    other_expenses: budget_expenses.other_expenses || 0,
                    rent_2: budget_expenses.rent_2 || 0,
                    auto_other: budget_expenses.auto_other || 0,
                    tv: budget_expenses.tv || 0,
                    charity: budget_expenses.charity || 0,
                    clothing: budget_expenses.clothing || 0,
                    education: budget_expenses.education || 0,
                    entertainment: budget_expenses.entertainment || 0,
                    health: budget_expenses.health || 0,
                    home_insurance: budget_expenses.home_insurance || 0,
                    household_items: budget_expenses.household_items || 0,
                    life_insurance: budget_expenses.life_insurance || 0,
                    laundry: budget_expenses.laundry || 0,
                    medical_care: budget_expenses.medical_care || 0,

                });
            },
            error => {
                this.setState({
                    showLoader: false,
                    error: true
                });
            }
        );
    }

    handleSubmit = (event) => {

        event.preventDefault();

        const { take_home_pay, other_income, alimony, child_support_gain, social_security, retirement_income, checking_account,
            checking_account_lien, savings_account, savings_account_lien, cash, cash_lien, property_balance, property_balance_lien,
            stocks, stocks_lien, vehicles, vehicles_lien, other_incomes, other_incomes_lien, rent, utilities, transportation,
            insurance_premiums, food, telephone, medical_bills, back_taxes, student_loans, child_support_loss, child_care, other_expenses,
            rent_2, auto_other, tv, charity, clothing, education, entertainment, health, home_insurance, household_items,
            life_insurance, laundry, medical_care } = this.state;

        let bodyFormData = new FormData();

        bodyFormData.append('is_crm', true);

        bodyFormData.append('take_home_pay', take_home_pay || 0);
        bodyFormData.append('other_income', other_income || 0);
        bodyFormData.append('alimony', alimony || 0);
        bodyFormData.append('child_support_gain', child_support_gain || 0);
        bodyFormData.append('social_security', social_security || 0);
        bodyFormData.append('retirement_income', retirement_income || 0);
        bodyFormData.append('checking_account', checking_account || 0);
        bodyFormData.append('checking_account_lien', checking_account_lien || 0);
        bodyFormData.append('savings_account', savings_account || 0);
        bodyFormData.append('savings_account_lien', savings_account_lien || 0);
        bodyFormData.append('cash', cash || 0);
        bodyFormData.append('cash_lien', cash_lien || 0);
        bodyFormData.append('property_balance', property_balance || 0);
        bodyFormData.append('property_balance_lien', property_balance_lien || 0);
        bodyFormData.append('stocks', stocks || 0);
        bodyFormData.append('stocks_lien', stocks_lien || 0);
        bodyFormData.append('vehicles', vehicles || 0);
        bodyFormData.append('vehicles_lien', vehicles_lien || 0);
        bodyFormData.append('other_incomes', other_incomes || 0);
        bodyFormData.append('other_incomes_lien', other_incomes_lien || 0);
        bodyFormData.append('rent', rent || 0);
        bodyFormData.append('utilities', utilities || 0);
        bodyFormData.append('transportation', transportation || 0);
        bodyFormData.append('insurance_premiums', insurance_premiums || 0);
        bodyFormData.append('food', food || 0);
        bodyFormData.append('telephone', telephone || 0);
        bodyFormData.append('medical_bills', medical_bills || 0);
        bodyFormData.append('back_taxes', back_taxes || 0);
        bodyFormData.append('student_loans', student_loans || 0);
        bodyFormData.append('child_support_loss', child_support_loss || 0);
        bodyFormData.append('child_care', child_care || 0);
        bodyFormData.append('other_expenses', other_expenses || 0);
        bodyFormData.append('rent_2', rent_2 || 0);
        bodyFormData.append('auto_other', auto_other || 0);
        bodyFormData.append('tv', tv || 0);
        bodyFormData.append('charity', charity || 0);
        bodyFormData.append('clothing', clothing || 0);
        bodyFormData.append('education', education || 0);
        bodyFormData.append('entertainment', entertainment || 0);
        bodyFormData.append('health', health || 0);
        bodyFormData.append('home_insurance', home_insurance || 0);
        bodyFormData.append('household_items', household_items || 0);
        bodyFormData.append('life_insurance', life_insurance || 0);
        bodyFormData.append('laundry', laundry || 0);
        bodyFormData.append('medical_care', medical_care || 0);

        callService(
            PUT,
            this.budgetURL,
            bodyFormData,
            response => {
                this.setState({ success: true, error: false });

                ReactGA.event({
                    category: 'Budget',
                    action: 'Budget Info Updated - General',
                });

                trackEvent('Budget', 'Budget Info Updated - General');
                this.componentDidMount();
            },
            error => {
                let msg = returnErrorMessage(error, "DefaultSaveError");
                this.setState({ success: false, error: true, errorMessage: msg });
            }
        );
    };

    render() {

        return (
            <div>
                <Divider hidden />
                <Form onSubmit={this.handleSubmit}>
                    <Grid stackable>
                        <Grid.Column width={16} className='grid-padding'>
                            <Segment>
                                <BudgetHeader
                                    showLoader={this.state.showLoader}
                                    expenses_total={this.state.budget_totals.expenses_total}
                                    incomes_total={this.state.budget_totals.incomes_total}
                                    cash_flow={this.state.budget_totals.cash_flow}
                                    dti={this.state.budget_totals.dti}
                                    assets_total={this.state.budget_totals.assets_total}
                                    liens_total={this.state.budget_totals.liens_total}
                                />
                            </Segment>
                        </Grid.Column>
                        <Grid.Column textAlign='right' width={16} className='grid-padding'>
                            {
                                this.state.success ?
                                    <Message size='tiny' color='green' icon='checkmark' content='Data saved successfully!' />
                                    : null
                            }
                            {
                                this.state.error ?
                                    <Message size='tiny' color='red' icon='cancel' content={this.state.errorMessage} />
                                    : null
                            }
                            <Button
                                icon='save'
                                type='submit'
                                primary
                                content='Save'
                            />
                        </Grid.Column>

                    </Grid>

                    <BudgetItem
                        updateStateProp={this.handleChange}
                        showLoader={this.state.showLoader}
                        take_home_pay={this.state.take_home_pay}
                        other_income={this.state.other_income}
                        alimony={this.state.alimony}
                        child_support_gain={this.state.child_support_gain}
                        social_security={this.state.social_security}
                        retirement_income={this.state.retirement_income}
                        checking_account={this.state.checking_account}
                        checking_account_lien={this.state.checking_account_lien}
                        savings_account={this.state.savings_account}
                        savings_account_lien={this.state.savings_account_lien}
                        cash={this.state.cash}
                        cash_lien={this.state.cash_lien}
                        property_balance={this.state.property_balance}
                        property_balance_lien={this.state.property_balance_lien}
                        stocks={this.state.stocks}
                        stocks_lien={this.state.stocks_lien}
                        vehicles={this.state.vehicles}
                        vehicles_lien={this.state.vehicles_lien}
                        other_incomes={this.state.other_incomes}
                        other_incomes_lien={this.state.other_incomes_lien}
                        rent={this.state.rent}
                        utilities={this.state.utilities}
                        transportation={this.state.transportation}
                        insurance_premiums={this.state.insurance_premiums}
                        food={this.state.food}
                        telephone={this.state.telephone}
                        medical_bills={this.state.medical_bills}
                        back_taxes={this.state.back_taxes}
                        student_loans={this.state.student_loans}
                        child_support_loss={this.state.child_support_loss}
                        child_care={this.state.child_care}
                        other_expenses={this.state.other_expenses}
                        rent_2={this.state.rent_2}
                        auto_other={this.state.auto_other}
                        tv={this.state.tv}
                        charity={this.state.charity}
                        clothing={this.state.clothing}
                        education={this.state.education}
                        entertainment={this.state.entertainment}
                        health={this.state.health}
                        home_insurance={this.state.home_insurance}
                        household_items={this.state.household_items}
                        life_insurance={this.state.life_insurance}
                        laundry={this.state.laundry}
                        medical_care={this.state.medical_care}
                    />

                </Form>
            </div>
        );

    }
}



// WEBPACK FOOTER //
// ./src/components/Budget/index.js